// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".selected-country[data-v-29d79a24]{align-items:center;cursor:pointer;display:flex}.selected-country .flag-image[data-v-29d79a24]{margin-right:1rem}.selected-country .flag-image svg[data-v-29d79a24]{border-radius:50%;display:block;width:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
